export class Time {
  constructor(public value: number) {}

  toString() {
    const minutes = this.getMinutes().toString().padStart(2, "0");
    const seconds = this.getSeconds().toString().padStart(2, "0");
    const millis = this.getMillis().toString().padStart(3, "0");
    return `${minutes}:${seconds}.${millis}`;
  }

  getMillis() {
    return this.value % 1000;
  }

  getSeconds() {
    return Math.floor(this.value / 1000) % 60;
  }

  getMinutes() {
    return Math.floor(this.value / 1000 / 60);
  }
}
